import 'whatwg-fetch';

const GOOGLE_FORM_PARTICIPANT_FORM_ID = '1LMeVrPoJar9pBP3O0QSlOjAMaKGjH4_5jD253iESATs';
const GOOGLE_FORM_PARTICIPANT_URL = `https://docs.google.com/forms/d/${GOOGLE_FORM_PARTICIPANT_FORM_ID}/formResponse`;
export const GOOGLE_FORM_PARTICIPANT_FIELD_NAME_EMAIL = 'entry.1926142699';

const GOOGLE_FORM_PENDING_FORM_ID = '1dbecGv8ehlGqsSBLXLf4RJE9DQ9oyAIErlLZiPmFXG4';
const GOOGLE_FORM_PENDING_URL = `https://docs.google.com/forms/d/${GOOGLE_FORM_PENDING_FORM_ID}/formResponse`;
export const GOOGLE_FORM_PENDING_FIELD_NAME_EMAIL = 'entry.1926142699';


export const postParticipant = (data) => (
  (dispatch) => {
    dispatch({type: 'PARTICIPANT_REGISTER_PENDING'});
    fetch(GOOGLE_FORM_PARTICIPANT_URL, {
      method: 'post',
      body: data,
      mode: 'no-cors',
      cache: 'default',
    })
      .then(response => {
        if (response.type === 'opaque' || response.ok) {
          dispatch({
            type: 'PARTICIPANT_REGISTER_DONE'
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
  }
);

export const postSponsor = (data) => (
  (dispatch) => {
    dispatch({type: 'SPONSOR_REGISTER_PENDING'});
    fetch(GOOGLE_FORM_PENDING_URL, {
      method: 'post',
      body: data,
      mode: 'no-cors',
      cache: 'default',
    })
      .then(response => {
        if (response.type === 'opaque' || response.ok) {
          dispatch({
            type: 'SPONSOR_REGISTER_DONE'
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
  }
);



// WEBPACK FOOTER //
// ./src/actions/google-form-action.js